import {
  ConditionalWrap,
  Flex,
  IconButton,
  LockIcon,
  Tooltip
} from '@libs/ui/ds'
import React from 'react'
import type { FC } from 'react'
import { useFormContext } from 'react-hook-form'

import { FieldLabel } from '../FormFields'
import type { FieldLabelProps } from '../FormFields/FieldLabel/FieldLabel'

import { InfoDotMissingValue } from './components/InfoDotMissingValue/InfoDotMissingValue'

type Props = {
  nameInput: string
  isSelect?: boolean
  dpaeAvailable?: boolean
  isLocked?: boolean
  onlyDpae?: boolean
  tooltipLabel?: string
} & FieldLabelProps

export const DpaeSSRFieldLabel: FC<Props> = ({
  nameInput,
  isSelect = false,
  dpaeAvailable = false,
  isLocked = false,
  onlyDpae = false,
  tooltipLabel = null,
  ...labelProps
}) => {
  const { watch } = useFormContext()

  return (
    <FieldLabel
      className='!m-0 flex-wrap gap-1'
      {...labelProps}
      rightComponent={
        <Flex row className='flex-nowrap items-center gap-1'>
          <InfoDotMissingValue
            dpaeAvailable={dpaeAvailable}
            nameInput={nameInput}
            isValueFilled={
              isSelect
                ? Boolean(watch(nameInput)?.value)
                : Boolean(watch(nameInput))
            }
            onlyDpae={onlyDpae}
          />

          {isLocked && (
            <ConditionalWrap
              condition={Boolean(tooltipLabel)}
              wrap={children => (
                // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
                <Tooltip label={tooltipLabel}>{children}</Tooltip>
              )}
            >
              <IconButton
                icon={<LockIcon />}
                size='s'
                variant='tertiary'
                intent='neutral-dark'
              />
            </ConditionalWrap>
          )}
        </Flex>
      }
    />
  )
}
